import { withDefaults } from '@warp-drive/legacy/model/migration-support';

export const UserSchema = withDefaults({
  type: 'users',
  fields: [
    {
      name: 'email',
      kind: 'attribute',
      type: 'string',
    },
    {
      name: 'displayName',
      kind: 'attribute',
      type: 'string',
    },
    {
      name: 'role',
      kind: 'attribute',
      type: 'string',
    },
  ],
});
